const metrics = [
    { value: "clicks", label: "Clicks" },
    { value: "downloads", label: "Downloads" },
    { value: "newDownloads", label: "New Downloads" }
];

const custom = {
    "download-clients": metrics.filter(m => m.value != "clicks"),
    "downloaded-episodes": metrics.filter(m => m.value != "clicks")
};

export const defaultMetric = report => custom[report]?.[0] ?? metrics[0];

export const reportMetrics = report => custom[report] ?? metrics;
